module.exports = __webpack_public_path__ + "img/A1.2e9afee8.png";